<script setup>
import employeeLeaves from '../../views/EmployeeLeaves.vue';

export default {
    props: {
        employeeLeaves: {
            type: Array,
            default: [],
        },
    },
    data() {
        return {
            columns: [
                { title: 'Leave Type', key: 'status' },
                { title: 'Date', key: 'clockInTime' },
            ],
        };
    },
};
</script>

<template>
    <div>
        <Table :columns="columns" :data="employeeLeaves"></Table>
    </div>
</template>

<style scoped lang="scss"></style>
